import { PostSchema } from '@ametista-ai/api-schema';
import { observer } from 'mobx-react-lite';
import { Button, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { PostContentHistory } from '@/components/Posts/PostModal/PostContentHistory';

export const ToggleActivityLogButton = observer(({ post }: { post: PostSchema }) => {
  const [opened, { toggle, close }] = useDisclosure(false);

  return (
    <>
      <Button variant="subtle" size="xs" onClick={toggle}>
        View history
      </Button>
      <Modal size="xl" opened={opened} onClose={close} title={`Version history for ${post.title}`}>
        <PostContentHistory post={post} />
      </Modal>
    </>
  );
});
